import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import {
    headers, getDDReturnListUrl,
    getDDReturnDetailsUrl,
    updateDDReturnUrl,
    GET_DDRETURN_LIST,
    GET_DDRETURN_DETAILS,
    UPDATE_DDRETURN,
} from "../../../utils/constants";

export const getDDReturnList_action = (ExhRegistrationID, DD_Number, DD_Date, HallID, ExhRegistrationNo, ExhibitorCompanyName, VendorName, ZoneID) => async (dispatch) => {
    try {
        const params = {
            // UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            ExhRegistrationID: ExhRegistrationID,
            DD_Number: DD_Number,
            DD_Date: DD_Date,
            HallID: HallID,
            ExhRegistrationNo: ExhRegistrationNo,
            ExhibitorCompanyName: ExhibitorCompanyName,
            VendorName: VendorName,
            ZoneID: ZoneID,
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(getDDReturnListUrl, params, headers)

        dispatch({
            type: GET_DDRETURN_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getDDReturnDetails_action = (ExhStallPossessionVendorDDdetailsID, EmpanelVendorDDdetailsID) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            ExhStallPossessionVendorDDdetailsID: ExhStallPossessionVendorDDdetailsID,
            EmpanelVendorDDdetailsID: EmpanelVendorDDdetailsID
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(getDDReturnDetailsUrl, params, headers)

        dispatch({
            type: GET_DDRETURN_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateDDReturn_action = (ExhStallPossessionVendorDDdetailsID, DDReturnedToPersonName, DDReturnedToEmaiID, DDReturnedToMobileNo, DDReturnedToCompanyName, FileName, FilePath, FileType, File, mailData) => async (dispatch) => {
    try {
        const mapData = {
            // UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhStallPossessionVendorDDdetailsID: ExhStallPossessionVendorDDdetailsID,
            DDReturnedToPersonName: DDReturnedToPersonName,
            DDReturnedToEmaiID: DDReturnedToEmaiID,
            DDReturnedToMobileNo: DDReturnedToMobileNo,
            DDReturnedToCompanyName: DDReturnedToCompanyName,
            FileName: FileName,
            FilePath: FilePath,
            FileType: FileType,
            File: File,
            mailData: mailData
        }
        console.log("addVisaApplication_action------->", mapData)
        const res = await axiosPost(updateDDReturnUrl, mapData, headers)

        dispatch({
            type: UPDATE_DDRETURN,
            payload: res
        })
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}